'use client';

import type React from 'react';

import { useState } from 'react';
import { useIntl } from 'react-intl';

import { AuthPanel, AuthPanelColumn, AuthPanelVariant } from '@vs-shop/commerce-ui/authPanel';
import { Notice } from '@vs-shop/ui/notice';

import RegistrationForm from './RegistrationForm';

type Props = {
  children: React.ReactNode;
};

export default function RegistrationWrapper({ children }: Props) {
  const [registrationSuccess, setRegistrationSuccess] = useState(false);

  const intl = useIntl();

  const onSuccess = () => {
    setRegistrationSuccess(true);
  };

  return (
    <AuthPanel variant={AuthPanelVariant.PLAIN}>
      {registrationSuccess && (
        <Notice>
          {intl.formatMessage({
            id: 'registration.wrapper.successMessage',
            defaultMessage:
              'Na registrační e-mail jsme poslali odkaz pro aktivaci uživatelského účtu.',
          })}
        </Notice>
      )}

      <AuthPanelColumn>
        {children}

        <RegistrationForm onSuccessAction={onSuccess} />
      </AuthPanelColumn>
    </AuthPanel>
  );
}
